import { PT_MASTERCATEGORY, PT_PRODUCT_LIST } from "../../../../routes/stack/paths/pt-home";
import { api_UpdateIsFavouriteForMerchant } from "../../../../connection/api/api-home";
import { Api_DrawAnalyticalPath } from "../../../../connection/api/api-Machine-Learning";
import { set_dto_Merchant } from "../../../../classes/dto-setters/dto-setter";
import { dto_Customer } from "../../../../classes/dto-customer";
import { dto_common } from "../../../../classes/dto-common";
import { F_Fammily } from "../../../../util/config-fonts";
import React from "react";
import "../../../../styles/css/pg-home-horozontalview-section.css";

export default class HorizontalSecion extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      HeartColor: props.data.IsFavourite ? 'red' : 'lightgrey',
      isTrue: props.data.IsFavourite
    };
  }

  handleHeartClick = async (MID, event) => {
    event.stopPropagation();
    const newIsTrue = !this.state.isTrue;
    let response = await api_UpdateIsFavouriteForMerchant(MID, newIsTrue);
    if (response === 'SUCCESS') {
      this.props.refreshHome();
      this.setState({
        HeartColor: newIsTrue ? 'red' : 'lightgrey',
        isTrue: newIsTrue
      });
    }
    
  };

  render() {
    let data = this.props.data;
    if (data.IL === "" || data.IL === "N/A") {
      data.IL = dto_common.defaultIL;
    }    

    return (
      <div
        className="pgHomeHorizontalSection"
        style={{ cursor: "pointer" }}
        key={data.MID + "MerchantSection"}
        onClick={() => {
          this.ClickHorizontalSecion(data);
        }}
      >
        <img src={data.IL} alt="image" />
        <div style={{ display: 'flex', alignItems: 'flex-start' }}>
          <div
            style={{
              flex: '87%',
              margin: 0,
              lineClamp: 2,
              WebkitLineClamp: 2,
              fontSize: 14,
              fontFamily: F_Fammily.Medium,
              marginRight: '3%',
            }}
          >
            {data.Merchant.trim()}
          </div>
          {dto_Customer.CSID > 0 && this.props.displayFav ?
            <div
              style={{
                flex: '10%',
                color: this.state.HeartColor,
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <i
                className='bi bi-heart-fill'
                // onClick={(event) => this.handleHeartClick(data.MID, event)}
              />
            </div>
            : null
          }

        </div>

        {data.IO === true ? (
          <div
            style={{
              margin: 0,
              lineClamp: 2,
              WebkitLineClamp: 2,
              width: 195,
              fontSize: 10,
              color: "green",
            }}
          >
            {data.MS.trim()}
          </div>
        ) : (

          <div
            style={{
              margin: 0,
              lineClamp: 2,
              WebkitLineClamp: 2,
              width: 280,
              fontSize: 10,
              color: "red",
            }}
          >
            {data.MS.trim()}
          </div>
        )}


      </div>
    );
  }

  async ClickHorizontalSecion(rs) {
    rs.CATID = 0;
    await Api_DrawAnalyticalPath(42, rs.MID);
    await set_dto_Merchant(rs);
    if (rs.MT.toUpperCase() === "GR" || rs.MT.toUpperCase() === "AF") {
      this.props.navigate(PT_MASTERCATEGORY);
    } else {
      this.props.navigate(PT_PRODUCT_LIST.replace(":navPage", "none").replace(
                            ":isSec",
                            "false"
                          ));
    }
  }
}